exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "footer#page-footer .page-footer-wrapper{overflow:hidden}footer#page-footer .page-footer-wrapper *,footer#page-footer .page-footer-wrapper :after,footer#page-footer .page-footer-wrapper :before{box-sizing:border-box}", ""]);

